"use client";

import { JSX, useState } from "react";
import PurseSeason3 from "@/components/Purse/PurseSeason3";
import PurseSeason1 from "@/components/Purse/PurseSeason1";
import PurseSeason2 from "@/components/Purse/PurseSeason2";
import PurseSeason4 from "@/components/Purse/PurseSeason4";
import PurseSeason5 from "@/components/Purse/PurseSeason5";

interface PurseProps {
  playersCount: number;
  tournamentName: string;
  tournamentId: string;
  tournamentSeason: number;
}

const Purse = ({
  playersCount,
  tournamentName,
  tournamentId,
  tournamentSeason,
}: PurseProps) => {
  const [inputVal, setInputVal] = useState("");

  const handleInputChange = (e: React.FormEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    setInputVal(target.value);
  };

  const baseProps = {
    inputVal,
    handleInputChange,
    playersCount,
    tournamentName,
    tournamentId,
  };

  const purseMap: Record<string, JSX.Element> = {
    season_1: <PurseSeason1 {...baseProps} />,
    season_2: <PurseSeason2 {...baseProps} />,
    season_3: <PurseSeason3 {...baseProps} />,
    season_4: <PurseSeason4 {...baseProps} />,
    season_5: <PurseSeason5 {...baseProps} />,
  };

  return (
    purseMap[`season_${tournamentSeason}`] ?? (
      <div>No purse available for this season.</div>
    )
  );
};

export default Purse;
